import { render, staticRenderFns } from "./HaricenTahsilatBildirimiTalepEvrakForm.vue?vue&type=template&id=f5ff0fa4"
import script from "./HaricenTahsilatBildirimiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./HaricenTahsilatBildirimiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports